/**
 * Formate un numéro de téléphone français avec des espaces
 * Ex: "0612345678" -> "06 12 34 56 78"
 */
export const formatPhoneNumber = (value: string): string => {
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length === 0) return '';
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 4) return `${cleaned.slice(0, 2)} ${cleaned.slice(2)}`;
  if (cleaned.length <= 6) return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 4)} ${cleaned.slice(4)}`;
  if (cleaned.length <= 8) return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 4)} ${cleaned.slice(4, 6)} ${cleaned.slice(6)}`;
  
  return `${cleaned.slice(0, 2)} ${cleaned.slice(2, 4)} ${cleaned.slice(4, 6)} ${cleaned.slice(6, 8)} ${cleaned.slice(8, 10)}`;
};

/**
 * Nettoie un numéro de téléphone pour la base de données
 * Ex: "06 12 34 56 78" -> "0612345678"
 */
export const cleanPhoneNumber = (value: string): string => {
  return value.replace(/\D/g, '');
};

/**
 * Valide un numéro de téléphone français (10 chiffres commençant par 0)
 */
export const validatePhoneNumber = (value: string): boolean => {
  const cleaned = cleanPhoneNumber(value);
  return /^0[1-9]\d{8}$/.test(cleaned);
};
